import * as yup from "yup";

export const workerValidationSchema = yup.object({
    salutation: yup.string().required("erforderlich"),
    firstName: yup.string().required("erforderlich"),
    lastName: yup.string().required("erforderlich"),
    email: yup.string().email().required("erforderlich"),
    phone: yup.string().required("erforderlich"),
    address: yup.object({
        formattedAddress: yup.string().required("erforderlich"),
        placeId: yup.string().required("erforderlich")
    }).required("erforderlich"),
    maxKmToOrder: yup.number().min(1).required("erforderlich"),
    hourlyWage: yup.number().min(1).required()
});